
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useProviderMinPrice = (providerId: string) => {
  return useQuery({
    queryKey: ['provider-min-price', providerId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('services')
        .select('price')
        .eq('provider_id', providerId)
        .not('price', 'is', null)
        .order('price', { ascending: true })
        .limit(1);

      if (error) {
        console.error('Error fetching provider min price:', error);
        throw error;
      }

      return data && data.length > 0 ? data[0].price : null;
    },
  });
};
